import styled from "styled-components";

export const Container = styled.main`
`

export const DetailContainer = styled.main`
  .inner{
    padding-top: 100px;
    padding-bottom: 100px;
    .date{
      margin: 12px 0 24px;
    }
    .description{
      padding: 24px 0;
      border-top: 1px solid var(--gray_be);
    }
  }
`